<template>
  <div class="pane_con">
    <el-input ref="use" style="width:310px;paddingBottom:10px;" v-model="username" placeholder="请输入手机号" prefix-icon="el-icon-s-custom"></el-input>
    <div style="position:relative">
      <!-- 短信按钮 -->
      <el-button :disabled="disab" class="time" @click="countt">{{counttime}}</el-button>
      <el-input style="width:310px;" v-model="password" placeholder="请输入验证码" prefix-icon="el-icon-lock" ></el-input>
    </div>
    <el-input
    style="width:310px;paddingTop:20px;paddingBottom:10px;"
      minlength="5"
      maxlength="10"
      placeholder="请输入5-10位新密码"
      v-model="password1"
      show-password
      prefix-icon="el-icon-lock"
    ></el-input>

    <el-button style="width:310px;" type="success" @click="update">修改</el-button>
  </div>
</template>

<script>
import Axios from "../../api/api"
export default {
  data() {
    return {
      disab: false,
      counttime: "验证码",
      username:"",
      password1: "",
      password: "", //验证码
      bool: true
    };
  },
  methods: {
    //修改密码
    update() {
      console.log(123);
      this.bool=false;
      if (this.password1.length < 5) {
        this.$message.error("请输入5-10位新密码");
      }
      Axios.update({
        phoneNumber:this.username,
        code:this.password,
        password:this.password1,
      })
      .then(res=>{
        // console.log(res)
        if(res.data.code==0&&res.status==200){
          this.bool=true;
           this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit("set",1)
        }else{
           this.$message.error(res.data.message);
        }
      })
      .catch(err=>{console.log(err)})
    },
    //时间倒计时
    countt() {
      if (!/^1[3456789]\d{9}$/.test(this.username)) {
        this.$refs.use.focus()
        this.username = "";
        this.$message({
          message: "请确认手机格式是否正确",
          type: "warning"
        });
        return;
      }
      this.counttime = 30;
      this.disab = true;
      this.relogin()
      var t = setInterval(() => {
        this.counttime--;
        if (this.counttime == 0) {
          this.disab = false;
          this.counttime = "验证码";
          clearInterval(t);
        }
      }, 1000);
    },
    relogin() {
      //ajax请求
      Axios.validation({
          phoneNumber: this.username
        })
        .then(res => {
         if(res.data.code==1){
          this.$messagse.error(res.data.message)
         }else{
           this.$message({
             message:res.data.data,
              type: 'success'
           })
         }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.time {
  position: absolute;
  bottom: 0;
  float: right;
  height: 40px;
  /* line-height: 40px; */
  z-index: 10;
  font-size: 0.1rem;
  right: 30px;

  color: #666;
  outline: none !important;
}
.time:focus {
  color: white;
}
.pane_con {
  position: relative;
  top: 119px;
  background: rgba(255, 255, 255, 0.2);
  width: 400px;
  height: 250px;
  padding: 30px 30px 10px 30px;
  margin: -0.58rem;
  margin-left: -10px;
  border-top-right-radius: 10px;
}
.el-input__inner {
  height: 45px;
}
.el-button--success {
  color: #fff;
  background: #00ab71;
  border-color: #00ab71;
  width: 100%;
  /* height:0.75rem; */
}

.el-button--success:hover {
  background: #05c786;
}
.el-button--success:focus {
  background: #05c786;
}
</style>